/**
 * @generated SignedSource<<a1cf58419542c5fd866d6d997bb0502e>>
 * @relayHash 832f4e667da8f12c77210c4660c41182
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fa8f12d778faffbbcb7869b21dc6a0087fc8477858b834ae51ae06c583ec1b59

import type { ConcreteRequest, Mutation } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraPublishBoardViewConfigInput = {
  settings?: JiraBoardViewSettings | null | undefined;
  viewId: string;
};
export type JiraBoardViewSettings = {
  filterJql?: string | null | undefined;
  groupBy?: string | null | undefined;
};
export type SaveResetViewSettingsPublishSettingsMutation$variables = {
  input: JiraPublishBoardViewConfigInput;
};
export type SaveResetViewSettingsPublishSettingsMutation$data = {
  readonly jira_publishBoardViewConfig: {
    readonly boardView: {
      readonly " $fragmentSpreads": FragmentRefs<"BoardHeader_view" | "SaveResetViewSettings_view">;
    } | null | undefined;
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly errorType: string | null | undefined;
        readonly statusCode: number | null | undefined;
      } | null | undefined;
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type SaveResetViewSettingsPublishSettingsMutation = {
  response: SaveResetViewSettingsPublishSettingsMutation$data;
  variables: SaveResetViewSettingsPublishSettingsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "kind": "ScalarField",
  "name": "message"
},
v4 = {
  "kind": "ScalarField",
  "name": "errorType"
},
v5 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = [
  {
    "kind": "ScalarField",
    "name": "fieldId"
  },
  {
    "kind": "ScalarField",
    "name": "fieldName"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "SaveResetViewSettingsPublishSettingsMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "JiraPublishBoardViewConfigPayload",
        "kind": "LinkedField",
        "name": "jira_publishBoardViewConfig",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "JiraBoardView",
            "kind": "LinkedField",
            "name": "boardView",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "SaveResetViewSettings_view"
              },
              {
                "kind": "FragmentSpread",
                "name": "BoardHeader_view"
              }
            ]
          },
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SaveResetViewSettingsPublishSettingsMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "JiraPublishBoardViewConfigPayload",
        "kind": "LinkedField",
        "name": "jira_publishBoardViewConfig",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "JiraBoardView",
            "kind": "LinkedField",
            "name": "boardView",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "kind": "ScalarField",
                "name": "canPublishViewConfig"
              },
              {
                "kind": "ScalarField",
                "name": "isViewConfigModified"
              },
              {
                "concreteType": "JiraViewGroupByConfig",
                "kind": "LinkedField",
                "name": "groupByConfig",
                "plural": false,
                "selections": (v7/*: any*/)
              },
              {
                "concreteType": "JiraViewGroupByConfig",
                "kind": "LinkedField",
                "name": "groupByOptions",
                "plural": true,
                "selections": (v7/*: any*/)
              }
            ]
          },
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v6/*: any*/)
                    ],
                    "type": "BulkMutationErrorExtension"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "fa8f12d778faffbbcb7869b21dc6a0087fc8477858b834ae51ae06c583ec1b59",
    "metadata": {},
    "name": "SaveResetViewSettingsPublishSettingsMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "7ed0f82d0e65763cd418c88dd8bb3e20";

export default node;
